import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const STORAGE_KEY = 'providerCookieConsent';

export function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) {
        setVisible(true);
      }
    } catch {
      /* ignore storage errors */
    }
  }, []);

  const decide = (choice) => {
    try {
      localStorage.setItem(STORAGE_KEY, choice);
    } catch {
      /* ignore storage errors */
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="provider-cookie" role="dialog" aria-label="Cookie consent">
      <p className="provider-cookie-text">
        We use essential cookies to keep you signed in and improve your experience. See our{' '}
        <Link to="/provider/cookies" className="provider-link">
          Cookie Policy
        </Link>{' '}
        for details.
      </p>
      <div className="provider-cookie-actions">
        <button
          type="button"
          className="provider-btn provider-btn--dark provider-btn--sm provider-btn--inline"
          onClick={() => decide('all')}
        >
          Accept all
        </button>
        <button
          type="button"
          className="provider-btn provider-btn--secondary provider-btn--sm provider-btn--inline"
          onClick={() => decide('essential')}
        >
          Essential only
        </button>
      </div>
    </div>
  );
}

export default CookieConsent;
